/* Video de un testimonio: miniatura con boton de play, arranca CON sonido al
   hacer clic. No usa el <video-js> del tema: ver README-gpets.md. */
class ReviewVideo extends HTMLElement {
  connectedCallback() {
    if (this.iniciado) return;
    this.iniciado = true;

    this.video = this.querySelector('video');
    this.boton = this.querySelector('.chm-reviews__play');
    if (!this.video) return;

    this.addEventListener('click', this.alternar.bind(this));
    this.video.addEventListener('ended', this.alReposo.bind(this));
    this.video.addEventListener('pause', this.alReposo.bind(this));
  }

  alternar(e) {
    // Con los controles nativos visibles, el clic sobre ellos es suyo.
    if (this.video.controls && e.target === this.video) return;

    if (this.video.paused) {
      // Solo suena uno a la vez.
      document.querySelectorAll('review-video').forEach(function (otro) {
        if (otro !== this && otro.video && !otro.video.paused) otro.video.pause();
      }, this);

      this.video.muted = false;
      this.video.controls = true;
      this.classList.add('reproduciendo');
      var p = this.video.play();
      // Si el navegador bloquea el audio, se reintenta en silencio antes que
      // dejar la tarjeta sin hacer nada.
      if (p && p.catch) {
        var v = this.video;
        var self = this;
        p.catch(function () {
          v.muted = true;
          v.play().catch(function () { self.alReposo(); });
        });
      }
    } else {
      this.video.pause();
    }
  }

  alReposo() {
    this.classList.remove('reproduciendo');
  }
}

if (!customElements.get('review-video')) {
  customElements.define('review-video', ReviewVideo);
}
